import { observer } from "mobx-react-lite";
import { Icon, Message } from "semantic-ui-react";
import { IAssessment } from "../../../Models/Assessment";
import { moduleTitles } from "../../Enums/TitleEnums";
import ComingSoonPlaceholder from "../ComingSoonPlaceholder";
import FamilyResourcesFactory from "./Factories/FamilyResourceFactory";
import LegalResourcesFactory from "./Factories/LegalResourcesFactory";
import MedicalResourceFactory from "./Factories/MedicalResourceFactory";
import SpiritualResourceFactory from "./Factories/SpiritualResourcesFactory";
import styles from "./Resources.module.css";

interface RenderResourcesProps {
    areInfoSlidesComplete: boolean;
    infoSlideIndex: number;
    assessment: IAssessment | null;
    domain: string;
  }

const RenderResources: React.FC<RenderResourcesProps> = (props) => {
    const {
      areInfoSlidesComplete,
      infoSlideIndex,
      assessment,
      domain
    } = props;
    
  const disclaimerMsg = () => {
    return (
      <>
        <Message className={styles.resourceMessage} warning icon={true} > 
          <Icon name='warning sign' />
          <Message.Content>
            <p>The resources below will link to external websites and are intended to be used as suggestions and references for informational 
              purposes only and are not meant to be taken as professional advice. The websites do not reflect the views of AgeReady. </p>
          </Message.Content>
        </Message>
      </>
    );
  }
  
  const resourcesRender = () => {
    const dom = areInfoSlidesComplete ? moduleTitles.COMING_SOON : domain;
    const key = areInfoSlidesComplete || assessment === null ? "" : assessment.questionForKey(assessment.infoSlideKeys[infoSlideIndex])?.key;
    switch (dom) {
      case moduleTitles.MEDICAL:
        return (
          <>
            <MedicalResourceFactory questionKey={key} />
          </>
        );
      case moduleTitles.LEGAL:
        return (
          <>
            <LegalResourcesFactory questionKey={key}  />
          </>
        );
      case moduleTitles.FAMILY:
        return (
          <>
            <FamilyResourcesFactory questionKey={key} />
          </>
        );
      case moduleTitles.SPIRITUAL:
        return (
          <>
            <SpiritualResourceFactory questionKey={key} />
          </>
        );
      default:
        return (
          <ComingSoonPlaceholder />
      );
    }
  };

  return (
    <>
      <div id={styles.resourcesDiv}>
        <div className={styles.resourcesRenderDiv}>
          {disclaimerMsg()}
          {resourcesRender()}
        </div>
      </div>
    </>
  );
}
export default observer(RenderResources);